export function getConfigProperty(mobileName, portalName) {
    return window.OPTIONS.properties ? window.OPTIONS.properties[portalName] : window.OPTIONS[mobileName];
}
